<template>
    <!--开评标监督记录-->
    <div>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>评标信息</span>
            </div>
            <template>
                <el-form class="form viewFormWrapper" label-width="175px" style="margin-bottom: 10px">
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="招标项目名称：">
                                <span>{{ projectInfo.projectName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="评标委员会名称：">
                                <span>{{ projectInfo.committeeName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="评标委员会类型：" prop="tenderAgencyPhone">
                                <span>{{ projectInfo.committeeType || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="专家库：" prop="tenderAgencyPhone">
                                <span>{{ projectInfo.expertBase || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="评标开始时间：" prop="tenderAgencyPhone">
                                <span>{{ projectInfo.pbBidopentime || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="开标时间：" prop="tenderAgencyPhone">
                                <span>{{ projectInfo.kbBidopentime || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="抽取专家人数：" prop="tenderAgencyPhone">
                                <span>{{ projectInfo.expertnumber || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="业主专家人数：" prop="tenderAgencyPhone">
                                <span>{{ projectInfo.tendereenumber || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="评审委员会人数：" prop="tenderAgencyPhone">
                                <span>{{ projectInfo.committeenumber || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="报到时间：" prop="tenderAgencyPhone">
                                <span>{{ projectInfo.arriveTime || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="评标地点：">
                                <span>{{ projectInfo.commentaddress || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="报到地点：">
                                <span>{{ projectInfo.arrivePlace || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="备注：">
                                <span>{{ projectInfo.remark || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="监督人员姓名：">
                                <span>{{ projectInfo.supervisorPersonName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>
            </template>

        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>抽取条件</span>
            </div>
            <template>
                <el-table
                        :data="projectInfo.gcExpertGroups"
                        border
                        style="width: 100%;margin-bottom: 20px">
                    <el-table-column
                            label="专家组"
                            prop="date"
                            width="180">
                        <el-table-column
                                align="center"
                                header-align="center"
                                label="序号"
                                type="index"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                label="专家组名称"
                                prop="expertName">
                        </el-table-column>
                        <el-table-column
                                label="所属区域"
                                prop="expertRegion">
                        </el-table-column>
                        <el-table-column
                                label="专业类别"
                                prop="expertType">
                        </el-table-column>
                        <el-table-column
                                label="抽取人数"
                                prop="expertNum">
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                prop="address">
                            <template slot-scope="scope">
                                <el-button title="查看" type="text" @click="getDetail(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
                <el-table
                        :data="projectInfo.gcExpertGroups"
                        border
                        :header-cell-style="tabHeader"
                        style="width: 100%;margin-bottom: 20px">
                    <el-table-column
                            label="回避设置"
                            prop="date">
                        <template>
                            <el-checkbox-group v-model="checkList">
                                <el-checkbox disabled label="回避招标人单位">回避招标人单位</el-checkbox>
                                <el-checkbox disabled label="回避招标代理单位">回避招标代理单位</el-checkbox>
                                <el-checkbox disabled label="回避投标人单位">回避投标人单位</el-checkbox>
                            </el-checkbox-group>

                        </template>

                    </el-table-column>
                </el-table>
                <template v-for="(ite,index) in  projectInfo.gcProfExtractAvoidsNews ">
                    <div v-if="ite.avoidunitType=='1'" :key="index">
                        <el-table
                                :data="[ite]"
                                border
                                style="width: 100%;margin-bottom: 20px">
                            <el-table-column
                                    label="其他回避单位"
                                    prop="date"
                                    width="180">
                                <el-table-column
                                        align="center"
                                        header-align="center"
                                        label="序号"
                                        type="index"
                                        width="80">
                                </el-table-column>
                                <el-table-column
                                        label="回避单位名称"
                                        prop="name">
                                </el-table-column>
                                <el-table-column
                                        label="企业代码"
                                        prop="code">
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-else-if="ite.avoidunitType=='2'">
                        <el-table
                                :data="[ite]"
                                border
                                style="width: 100%;margin-bottom: 20px">
                            <el-table-column
                                    label="回避专家"
                                    prop="date"
                                    width="180">
                                <el-table-column
                                        align="center"
                                        header-align="center"
                                        label="序号"
                                        type="index"
                                        width="80">
                                </el-table-column>
                                <el-table-column
                                        label="回避专家姓名"
                                        prop="name">
                                </el-table-column>
                                <el-table-column
                                        label="回避专家身份证号"
                                        prop="code">
                                </el-table-column>
                                <!--						<el-table-column-->
                                <!--							label="操作"-->
                                <!--							prop="address">-->
                                <!--							<template slot-scope="scope">-->
                                <!--								<el-button title="查看" type="text" @click="getDetail(scope.row)">查看</el-button>-->
                                <!--							</template>-->
                                <!--						</el-table-column>-->

                            </el-table-column>
                        </el-table>

                    </div>
                </template>

            </template>
        </el-card>

        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>业主专家</span>
            </div>
            <template>
                <el-table
                        :data="projectInfo.gcOwnerExperts"
                        border
                        style="width: 100%">
                    <el-table-column
                            label="业主专家"
                            prop="date"
                            width="180">
                        <el-table-column
                                align="center"
                                header-align="center"
                                label="序号"
                                type="index"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                label="姓名"
                                prop="ownerExpertsName">
                        </el-table-column>
                        <el-table-column
                                label="性别"
                                prop="ownerExpertsSex">
                        </el-table-column>
                        <el-table-column
                                label="身份证号码"
                                prop="identityCard">
                        </el-table-column>
                        <el-table-column
                                label="工作单位"
                                prop="ownerExpertsWork">
                        </el-table-column>
                        <el-table-column
                                label="联系方式"
                                prop="ownerExpertsMobile">
                        </el-table-column>
                    </el-table-column>

                </el-table>
            </template>
        </el-card>

        <el-dialog :visible.sync="imgDialogVisible" center height="100%" title="专家组抽取信息" width="60%"
                   @closed="dialogClose" @opened="dialogOpen">
            <template v-if="projectInfo.evaluationType=0">
                <el-form class="form viewFormWrapper" label-width="175px" style="margin-bottom: 10px">
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="专家组名称：">
                                <span>{{ projectInfoDet.expertName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="抽取人数：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.expertNum || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="最高年龄：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.highestAge || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="专业类别：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.expertType || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="专业分类：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.specialtyType || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="评标专业：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.tenderAgencyName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="从事行业：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.tenderAgencyName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="专家所属地区：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.tenderAgencyName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="评标地区：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.tenderAgencyName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="职称：">
                                <span>{{ projectInfoDet.bidSectionName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="执业资格：">
                                <span>{{ projectInfoDet.bidSectionName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </template>
            <template v-if="projectInfo.evaluationType=1">
                <el-form class="form viewFormWrapper" label-width="175px" style="margin-bottom: 10px">
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="专家组名称：">
                                <span>{{ projectInfoDet.expertName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="抽取人数：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.expertNum || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="最高年龄：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.highestAge || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="专业类别：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.specialtyType || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="专业分类：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.expertType || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="评标专业：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.bidEvaluationDiscipline || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="从事行业：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.industry || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="12">
                            <el-form-item label="专家所属地区：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.expertRegion || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="评标地区：" prop="tenderAgencyPhone">
                                <span>{{ projectInfoDet.bidEvaluationArea || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="职称：">
                                <span>{{ projectInfoDet.professional || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="执业资格：">
                                <span>{{ projectInfoDet.practice || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="评标交易中心：">
                                <span>{{ projectInfoDet.tradingCenter || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="评标地点：">
                                <span>{{ projectInfoDet.evaluationPlace || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :span="20">
                        <el-col :span="20">
                            <el-form-item label="报到地点：">
                                <span>{{ projectInfoDet.reportPlace || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </template>

        </el-dialog>
    </div>

</template>

<script>
    export default {

        props: {
            nodeCode: {
                type: String,
                defalut: 'GC00053'
            },
            purchaserMode: {
                type: String,
                defalut: ''
            },
            title: {
                type: String,
                defalut: ''
            },
            total: {
                type: Number,
                defalut: 0
            },
            projectInfo: {
                type: Object,
                default: () => ({})
            },


        },
        watch: {},
        data() {
            return {
                dialogImageUrl: '',
                imgDialogVisible: false,
                projectInfoDet: {},
                checkList: ['回避招标人单位','回避招标代理单位','回避投标人单位']
                // 测试数据
                // projectInfo: {
                // 	Ownerexpert: [],
                // 	tableData: [
                // 		{
                // 			id: ''
                // 		}
                // 	]
                // },


            }
        },
        activated() {

        },
        methods: {
            tabHeader() {
                return 'backgroundColor:#F5F7FA;color:#909399'
            },
            getDetail(item) {
                this.imgDialogVisible = true;
                this.projectInfoDet = item;
            },

            dialogOpen() {
                this.$nextTick(() => {
                    this.iframeInsert(this.$el);
                });
            },

            dialogClose() {
                this.dialogImageUrl = "";
                this.imgDialogVisible = false;
            },

        }


    }
</script>

<style lang="less" scoped>
    .eval_table {
        padding: 0;
        margin: 0;
        border: 1px solid #ebeef5;
        border-spacing: 0;
        border-collapse: collapse;
        text-align: center;
        table-layout: fixed;
        word-break: break-all;
        word-wrap: break-word;

        th {
            border: 1px solid #ebeef5;
            padding: 4px 8px;
            background-color: rgb(245, 247, 250);
            margin: 0;
            height: 44px;
            border-spacing: 0;
            border-collapse: collapse;
            color: #909399;
            font-weight: 500;
        }


        td {
            padding: 4px 8px;
            margin: 0;
            border-collapse: collapse;
            border-spacing: 0;
            border: 1px solid #ebeef5;

            p {
                margin: 0;
            }

            span {
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .el-button {
                border: none;
                padding: 0;
                margin: 0;

                &:hover {
                    background: transparent;
                }
            }

            &.pdf {
                width: 500px;
                text-align: left;
            }
        }


    }
</style>
